// Module
var code = `<section class="page-body default-content">
<!--
  <article class="hero-component">
    <div class="hero__layout">
      <div class="hero__content">
        <span class="hero__eyebrow">Welcome to Our Platform</span>
        <h1 class="hero__headline">Build Something Amazing Today</h1>
        <p class="hero__subheadline">Transform your ideas into reality with our powerful tools and intuitive design system that scales with your needs.</p>
        <a href="#" class="btn btn-primary px-8 hero__cta">Get Started</a>
      </div>
      <div class="hero__image">
        <img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&amp;q=80" alt="Hero image" />
      </div>
    </div>
  </article>

  -->
</section>
`;
// Exports
module.exports = code;